import { NgModule } from "@angular/core";
import { AmountPipe } from "./amount/amount.pipe";
import { TimeagoPipe } from "./timeago/timeago";
@NgModule({
  declarations: [TimeagoPipe, AmountPipe],
  imports: [],
  exports: [TimeagoPipe, AmountPipe],
})
export class PipesModule {}



// WEBPACK FOOTER //
// ./src/app/pipes/pipes.module.ts